import { ConstructionYear } from "@tm/models"

export function constructionYearToString(date?: ConstructionYear) {
    if (!date) {
        return ""
    }

    return `${date.month}/${date.year}`
}
